import { baseKey } from '@otp/utils/baseDataConfig';

export default {
    dialogForm: {
        gutter: 20,
        labelWidth: 6,
        inputWidth: 18,
        inline: true,
        btnSpan: 3,
        inputList: [
            {
                label: '客户订单号',
                mustFill: true,
                readOnly: true,
                disabled: true,
                prop: 'customerOrderNo',
                value: 'customerOrderNo',
                span: 6,
                type: 'text'
            },
            {
                ...baseKey.customer,
                // cbParams: ['pmCode#upperCustomerCode', 'ebcuNameCn#upperCustomerName'],
                label: '客户名称',
                readOnly: true,
                // prop: 'upperCustomerName',
                // value: 'upperCustomerName',
                span: 6,
                type: 'advance'
            },
            {
                ...baseKey.site,

                label: '服务平台',
                mustFill: false,
                readOnly: true,
                prop: 'siteName',
                value: 'siteName',
                span: 6,
                type: 'advance'
            },
            {
                ...baseKey.wh,
                advanceConfig: [
                    { prop: 'codeAndName', value: '仓库编码或名称' }
                    // { prop: 'cdwhName', value: '仓库名称' },
                    // { prop: 'whCode', value: '仓库编码' }
                ],
                label: '仓库',
                prop: 'whName',
                value: 'whName',

                type: 'advance',
                mustFill: false,
                readOnly: true,
                span: 6
            },
            {
                label: '订单类型',
                prop: 'orderType',
                value: 'orderType',
                type: 'dictionary',
                readOnly: true,
                multiple: false,
                optionNum: 'ORDER_TYPE_NEW',
                options: [],
                disabledOptions: [],
                span: 6
            },
            {
                label: '配送方式',
                prop: 'deliveryType',
                value: 'deliveryType',
                type: 'dictionary',
                mustFill: false,
                optionNum: 'DELIVERY_TYPE',
                options: [],
                disabledOptions: [],
                multiple: false,
                span: 6
            },
            {
                label: '业务模式',
                prop: 'businessMode',
                value: 'businessMode',
                type: 'dictionary',
                mustFill: true,
                readOnly: true,
                optionNum: 'BUSINESS_MODE',
                options: [],
                disabledOptions: [],
                multiple: false,
                span: 6
            },
            {
                label: '货值',
                prop: 'orderValue',
                value: 'orderValue',
                disabled: true,
                span: 6,
                type: 'text'
            },
            {
                label: '是否零担',
                prop: 'loadType',
                value: 'loadType',
                type: 'dictionary',
                mustFill: false,
                readOnly: true,
                optionNum: 'LOAD_TYPE', // YES_OR_NO、TMS_YES_OR_NO
                options: [],
                disabledOptions: [],
                multiple: false,
                span: 6
            },
            {
                label: '运费类型',
                prop: 'deliverypayType',
                value: 'deliverypayType',
                type: 'dictionary',
                mustFill: false,
                readOnly: true,
                optionNum: '',
                options: [
                    { value: 1, label: '寄付' },
                    { value: 2, label: '到付' }
                ],
                disabledOptions: [],
                multiple: false,
                span: 6
            },
            {
                label: '是否代收',
                prop: 'collectionFlag',
                value: 'collectionFlag',
                type: 'dictionary',
                mustFill: false,
                readOnly: true,
                optionNum: 'TMS_YES_OR_NO', // YES_OR_NO、TMS_YES_OR_NO
                options: [],
                disabledOptions: [],
                multiple: false,
                span: 6
            },
            {
                label: '计费标准',
                prop: 'freightBasis',
                value: 'freightBasis',
                type: 'dictionary',
                mustFill: false,
                readOnly: true,
                optionNum: 'SYS_OTP_FREIGHT_BASIS',
                options: [],
                disabledOptions: [],
                multiple: false,
                span: 6
            },
            {
                label: '备注',
                prop: 'remark',
                value: 'remark',
                type: 'text',
                span: 12,
                labelWidth: 3,
                inputWidth: 21
            },
            {
                label: '',
                prop: '',
                value: '',
                isHideShow: true,
                span: 12,
                type: 'text'
            },

            {
                label: '发货人',
                prop: 'senderName',
                value: 'senderName',
                span: 6,
                type: 'text'
            },
            {
                label: '电话',
                prop: 'senderMobile',
                value: 'senderMobile',
                span: 6,
                type: 'text'
            },
            {
                label: '',
                prop: '',
                value: '',
                isHideShow: true,
                span: 12,
                type: 'text'
            },
            {
                label: '发货地址',
                prop: 'sendAddress',
                value: 'sendAddress',
                type: 'addressCascader',
                config: {
                    checkStrictly: true
                },
                labelWidth: 3,
                inputWidth: 21,
                span: 12
            },
            {
                label: '一一',
                prop: 'senderDetailAddr',
                value: 'senderDetailAddr',
                type: 'autocomplete',
                placeholder: '请输入发货详情地址',
                autoConfig: {
                    html(scope) {
                        return `
                            <div class="name">${scope.item.value}</div>
                            <span class="addr">${scope.item.provinces}</span>
                        `;
                    }
                },
                span: 12,
                labelWidth: 2,
                inputWidth: 22
            },

            {
                label: '收货人',
                prop: 'receiverName',
                value: 'receiverName',
                span: 6,
                type: 'text'
            },
            {
                label: '电话',
                prop: 'receiverMobile',
                value: 'receiverMobile',
                span: 6,
                type: 'text'
            },
            {
                label: '',
                prop: '',
                value: '',
                isHideShow: true,
                span: 12,
                type: 'text'
            },
            {
                label: '收货地址',
                prop: 'receiverAddress',
                value: 'receiverAddress',
                type: 'addressCascader',
                config: {
                    checkStrictly: true
                },
                labelWidth: 3,
                inputWidth: 21,
                span: 12
            },
            {
                label: '一一',
                prop: 'receiverDetailAddr',
                value: 'receiverDetailAddr',
                type: 'autocomplete',
                placeholder: '请输入收货详情地址',
                autoConfig: {
                    html(scope) {
                        return `
                            <div class="name">${scope.item.value}</div>
                            <div class="addr">${scope.item.provinces}</div>
                        `;
                    }
                },
                span: 12,
                labelWidth: 2,
                inputWidth: 22
            }
        ]
    },
    dialogItemsTable: {
        selection: false,
        allowRowClick: false,
        control: true,
        height: 200,
        columns: [
            {
                label: '上游商品名称',
                prop: 'upperItemName',
                value: 'upperItemName',
                width: 160
            },
            {
                label: '上游商品编码',
                prop: 'upperItemCode',
                value: 'upperItemCode',
                width: 140
            },
            {
                label: '商品名称',
                prop: 'itemName',
                value: 'itemName',
                width: 160
            },
            {
                label: '商品编码',
                prop: 'itemCode',
                width: 140
            },
            {
                label: '商品行号',
                prop: 'upperLineNo',
                width: 140
            },
            {
                label: '商品类别',
                prop: 'itemClassName',
                width: 120
            },
            {
                label: '商品名称',
                prop: 'itemName',
                width: 160
            },
            {
                label: '商品编码',
                prop: 'itemCode',
                width: 140
            },
            {
                label: '商品件型',
                prop: 'itemSize',
                width: 120
            },
            {
                label: '商品计费件型',
                prop: 'itemChargingType',
                width: 140
            },
            {
                label: '商品状态',
                prop: 'itemStatus',
                type: 'select',
                optionsKey: 'O_ITEM_STATUS',
                disabled: true,
                width: 110
            },
            {
                label: '目标商品状态',
                prop: 'itemStatusTo',
                type: 'select',
                optionsKey: 'O_ITEM_STATUS',
                disabled: true,
                width: 140
            },
            {
                label: '上游商品状态',
                prop: 'upperItemStatus',
                type: 'select',
                optionsKey: 'O_ITEM_STATUS',
                disabled: true,
                width: 140
            },
            {
                label: '上游目标商品状态',
                prop: 'upperItemStatusTo',
                type: 'select',
                optionsKey: 'O_ITEM_STATUS',
                disabled: true,
                width: 140
            },
            {
                label: '计划数量',
                prop: 'planQty',
                width: 80
            },
            {
                label: '实际数量',
                prop: 'actQty',
                width: 80
            },
            {
                label: '单台体积',
                prop: 'volume',
                type: 'input',
                width: 100
            },
            {
                label: '单台毛重',
                prop: 'grossWeight',
                type: 'input',
                width: 100
            },
            {
                label: '单台净重',
                prop: 'netWeight',
                width: 100
            },
            {
                label: '商品单价',
                prop: 'price',
                width: 80
            },
            {
                label: '商品金额',
                prop: 'amout',
                width: 80
            },
            {
                label: '单位',
                prop: 'unit',
                width: 80
            },
            {
                label: 'sn码',
                prop: 'snCode',
                width: 80
            },
            {
                label: '批次号',
                prop: 'batchCode',
                width: 140
            },
            {
                label: '生产批号',
                prop: 'produceCode',
                width: 80
            },
            {
                label: '过期日期',
                prop: 'expireTimestamp',
                width: 150
            },
            {
                label: '产品型号',
                prop: 'itemSpec',
                width: 100
            },
            {
                label: '计费组1',
                prop: 'materialGroup1',
                width: 100
            },
            {
                label: '计费组2',
                prop: 'materialGroup2',
                width: 100
            },
            {
                label: '计费组3',
                prop: 'materialGroup3',
                width: 100
            },
            {
                label: '计费组4',
                prop: 'materialGroup4',
                width: 100
            },
            {
                label: '计费组5',
                prop: 'materialGroup5',
                width: 100
            },
            {
                label: '计费组6',
                prop: 'materialGroup6',
                width: 100
            },
            {
                label: '未含税价',
                prop: 'notaxPrice',
                width: 80
            },
            {
                label: '市场型号',
                prop: 'marketModel',
                width: 80
            },
            {
                label: '国际条形码',
                prop: 'barcode69',
                width: 100
            },
            {
                label: '拒收',
                prop: 'rejectQty',
                width: 80
            },
            {
                label: '短少',
                prop: 'stockoutCount',
                width: 80
            },
            {
                label: '是否上楼',
                prop: 'isUpperStair',
                width: 80
            },
            {
                label: '目标商品编码',
                prop: 'toItemCode',
                width: 120
            },
            {
                label: '目标客户商品编码',
                prop: 'toCustomerItemCode',
                width: 140
            },
            {
                label: '单行总体积',
                prop: 'totalVolume',
                width: 120
            },
            {
                label: '单行总毛重',
                prop: 'totalGrossWeight',
                width: 120
            },
            {
                label: '是否虚拟商品',
                prop: 'fictitiousFlag',
                width: 120
            },
            {
                label: '包装规格',
                prop: 'cdpaFormat',
                width: 100
            }
        ]
    }
};
